// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"8ebba7af","297":"ea8aca06","643":"be51b74d"}[chunkId] + ".chunk.js";
};